import React from "react";
import {
  TransactionGraph,
  getBlockheight,
  getBlocksCount,
  getWOOOOPrice,
  getTransctionCount,
} from "./ApiCall";
import token1 from "../../src/Assets/Images/token-1.png";
import token2 from "../../src/Assets/Images/token-2.png";
import token3 from "../../src/Assets/Images/token-3.png";
import token4 from "../../src/Assets/Images/token-4.png";
import Graph from "../../src/Assets/Images/graph.jpg";
import { useEffect } from "react";
import { useState } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";

function HomeBlock() {
  const [blocksCount, setBlocksCount] = useState([]);
  const [transactionCount, setTransationCount] = useState([]);
  const [WOOOOprice, setWOOOOPrice] = useState([]);
  const priceValue = parseFloat(WOOOOprice.price);
  const [data, setdata] = useState();
  const [Aprs, setAprs] = useState();
  const formattedPrice = isNaN(priceValue)
    ? "--"
    : priceValue.toFixed(4).padStart(4, "0");

  const BlocksCount = async () => {
    getBlockheight()
      .then((blockcount) => {
        setBlocksCount(blockcount.data);
      })
      .catch(() => {});
  };
  const fetchPrice = async () => {
    getWOOOOPrice()
      .then((price) => {
        setWOOOOPrice(price.data);
      })
      .catch(() => {});
  };
  const TransactionCount = async () => {
    getTransctionCount()
      .then((transactioncount) => {
        setTransationCount(transactioncount.data);
      })
      .catch(() => {});
  };
  const Graph = async () => {
    TransactionGraph()
      .then((temp) => {
        setAprs(temp.data.Date.reverse());
        setdata(temp.data.Transaction.reverse());
      })
      .catch(() => {});
  };
  useEffect(() => {
    BlocksCount();
    fetchPrice();
    TransactionCount();
    Graph();

    const intervalId = setInterval(() => {
      BlocksCount();
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  const option = {
    xAxis: {
      type: "category",
      data: Aprs,
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (value) => {
          if (value >= 1000) {
            return `${value / 1000}K`;
          }
          return value;
        },
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        formatter: (value) => {
          if (value >= 1000) {
            return `${value / 1000}K`;
          }
          return value;
        },

        interval: 10, // Adjust the interval value to change the gap between y-axis points
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
      formatter: (params) => {
        const dataIndex = params[0].dataIndex;
        const transactionCount = data[dataIndex];
        const formattedTransactionCount =
          transactionCount >= 1000
            ? `${transactionCount / 1000}K`
            : transactionCount;
        const date = Aprs[dataIndex];
        return `Date: ${date}<br />Transaction Count: ${formattedTransactionCount}`;
      },
    },
    series: [
      {
        data: data,
        type: "line",
        smooth: true,
      },
    ],
  };
  return (
    <div>
      <div className="full-div about-token-panel">
        <ul className="about-token-list">
          <li>
            <div className="token-pnl brder">
              <img src={token1} alt="Token" />
              <div className="txt-pnl">
                <p>AMG PRICE</p>
                <h4>$ {formattedPrice} </h4>
              </div>
            </div>
            <div className="token-pnl">
              <img src={token2} alt="Token" />
              <div className="txt-pnl">
                <p>AMG MARKET CAP</p>
                <h4>--</h4>
              </div>
            </div>
          </li>
          <li>
            <div className="token-pnl brder">
              <img src={token4} alt="Token" />
              <div className="txt-pnl">
                <p>TOTAL TRANSACTIONS</p>
                <h4>
                  {transactionCount.count ?? "--"}
                  {/* ? transactionCount?.count?.slice(0, 2) +
                      "," +
                      transactionCount?.count
                        ?.slice(2)
                        .replace(/(\d{3})(?=\d)/g, "$1,")
                    } */}
                </h4>
              </div>
            </div>
            <div className="token-pnl">
              <img src={token3} alt="Token" />
              <div className="txt-pnl">
                <p>LATEST BLOCK</p>
                <h4>
                  {/* {blocksCount.data?? "--"} */}
                  {blocksCount && blocksCount.data
                    ? blocksCount?.data.slice(0, 2) +
                      "," +
                      blocksCount.data
                        ?.slice(2)
                        .replace(/(\d{3})(?=\d)/g, "$1,")
                    : "--"}
                </h4>
              </div>
            </div>
          </li>
          <li>
            <p>AMG CHAIN TRANSACTION HISTORY LAST 14 Days</p>

            <ReactEcharts
              className="Echarts"
              echarts={echarts}
              option={option}
            />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default HomeBlock;
